import { SVGProps } from "react";

const CheckV2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={9.31}
    data-name="Group 12628"
    {...props}
  >
    <defs>
      <clipPath id="check-a-clip-path">
        <path fill="#fff" d="M0 0h12v9.31H0z" data-name="Rectangle 4833" />
      </clipPath>
    </defs>
    <g clipPath="url(#check-a-clip-path)" data-name="Group 11043">
      <path
        fill="#fff"
        d="M4.171 6.134a1.824 1.824 0 0 1 .13-.167L9.935.325a.925.925 0 0 1 .975-.282 1.059 1.059 0 0 1 .367.212 5.81 5.81 0 0 1 .468.464.911.911 0 0 1 .015 1.249c-.032.036-.065.07-.1.1l-7 7a.68.68 0 0 1-.5.238.6.6 0 0 1-.437-.183L.279 5.676a.905.905 0 0 1 .015-1.321l.4-.4a.91.91 0 0 1 1.332 0c.68.673 1.354 1.351 2.029 2.028.034.034.06.075.12.15"
        data-name="Path 19522"
      />
    </g>
  </svg>
);
export default CheckV2;
